<template>
    <!-- <div class="category-wrapper">
            <a
                class="category-item"
                v-for="category in categories"
                :key="category.index"
                :href="category.url"
            >
                <div class="image"></div>
                <div class="category-info">
                    <div class="products-quantity"></div>
                    <div class="name">{{ category.name }}</div>
                </div>
                <i class="icon icon-chevronright"></i>
            </a>
        </div> -->

    <div class="category-wrapper">
        <div
            class="category-body"
            v-for="category in categories"
            v-if="category.product_count > 0 && !category.is_all_hidden"
            :key="category.id"
        >
            <div
                class="category-item category-item-container"
                :class="isCurrentUrl(category.id) ? 'active' : ''"
                @click="onCategoryTap(category.id)"
            >
                <div class="category-content">
                    <div
                        class="category-main"
                        :class="`sub-category-level-${subCategoryLevel}`"
                    >
                        <div class="category-info">
                            <div
                                v-if="category.id > 0 || category.virtual_count"
                                class="products-quantity"
                            >
                                {{ productCountText(category.id > 0 ? category.product_count : category.virtual_count) }}
                            </div>
                            <div class="name theme-primary-color">
                                {{ category.name }}
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="category.children?.length && checkChildrenProductCount(category)"
                        class="arrow-right"
                        :class="{ open: isDropdownOpen(category.id) }"
                        @click.stop="toggleDropdown(category.id)"
                    >
                        <i class="icon-chevronright"></i>
                    </div>
                </div>
            </div>
            <div
                v-if="category.children?.length && isDropdownOpen(category.id)"
                class="category-nested"
            >
                <div class="category-nested-items">
                    <bo-mobile-category
                        :categories="category.children"
                        :sub-category-level="subCategoryLevel + 1"
                        :is-return-mode="isReturnMode"
                        :current-category-id="currentCategoryId"
                        :embedded="embedded"
                        @product_category_id="selectProductCategory"
                    >
                    </bo-mobile-category>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import BoPoint from "js/frontend/components/bo-point.vue";
import BoMobileDropdown from "js/frontend/components/bo-mobile-catalog-dropdown.vue";
Vue.component("bo-point", BoPoint);
Vue.component("bo-mobile-catalog-dropdown", BoMobileDropdown);

export default {
    components: { BoPoint },

    props: {
        categories: {
            type: Array,
            default: "",
        },
        isReturnMode: {
            type: Boolean,
            default: false,
        },
        subCategoryLevel: {
            type: Number,
            default: 0,
        },
        currentCategoryId: {
            type: Number,
            default: null,
        },
        // #111877: when rendered in-page on the catalog page, selections emit
        // product_category_id instead of navigating to a new page. Default false
        // keeps the standalone mobile_category page behaviour unchanged.
        embedded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            openDropdowns: {},
            returnPopup: null,
            currentUrl: null,
            showCatalog: false,
            generalTranslations: window.bo?.generalTranslations ?? {},
            catalogTranslations: window.bo?.catalogTranslations ?? {},
        };
    },
    computed: {},
    created() {},
    methods: {
        productCountText(count) {
            return (this.catalogTranslations.products_count ?? ":count Products").replace(":count", count ?? 0);
        },
        isCurrentUrl(url) {
            let currentUrl = window.location.href;
            let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
            let textId = text.split("#")[0];
            return textId == url;
        },
        selectProductCategory(productCategoryId) {
            this.$emit("product_category_id", productCategoryId);
        },
        // #111877: embedded (in-page picker) selections emit to the parent for a
        // client-side switch; the standalone page keeps its full-page navigation.
        onCategoryTap(productCategoryId) {
            if (this.embedded) {
                this.selectProductCategory(productCategoryId);
            } else {
                this.mobileSelectedProductCategory(productCategoryId);
            }
        },
        toggleDropdown(categoryId) {
            const currentVisibleState = this.isDropdownOpen(categoryId);
            this.$set(this.openDropdowns, categoryId, !currentVisibleState);
        },
        isDropdownOpen(categoryId) {
            if (this.openDropdowns[categoryId] !== undefined) {
                return this.openDropdowns[categoryId];
            }
            // Check if the dropdown is manually opened or if any subcategory is active
            const category = Object.values(this.categories).find((cat) => cat.id === categoryId);
            return category ? this.checkActiveSubcategory(category) : false;
        },
        checkActiveSubcategory(category) {
            if (category.id === this.getCurrentCategoryId()) {
                return true;
            } else if (category.children) {
                return category.children.some((subcategory) => {
                    return this.checkActiveSubcategory(subcategory);
                });
            } else {
                return false;
            }
        },
        getCurrentCategoryId() {
            if (this.currentCategoryId !== null) {
                return this.currentCategoryId;
            }

            let currentUrl = window.location.href;
            if (!currentUrl.includes("category/")) {
                return null;
            }

            let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
            let textId = text.split("#")[0].split("?")[0];
            const currentCategoryId = parseInt(textId);

            return isNaN(currentCategoryId) ? null : currentCategoryId;
        },
        mobileSelectedProductCategory(productCategoryId) {
            let currentUrl = window.location.href;
            // Different link for return mode
            if (this.isReturnMode) {
                let baseUrl = currentUrl.substring(0, currentUrl.lastIndexOf("catalog/"));
                const targetUrl = baseUrl + "return/catalog/category/" + productCategoryId.toString();
                window.location.href = targetUrl;
            } else {
                let baseUrl = currentUrl.substring(0, currentUrl.lastIndexOf("mobile_category/"));
                const targetUrl = baseUrl + "category/" + productCategoryId.toString();
                window.location.href = targetUrl;
            }
        },
        checkChildrenProductCount(category) {
            if (category.has_visible_children !== undefined) {
                return category.has_visible_children;
            }

            if (category.children && category.children.length > 0) {
                return category.children.some((child) => child.product_count > 0);
            } else {
                return false;
            }
        },
    },
};
</script>
